import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { env } from '@config/env';
import { startPanicAlarmLoop, stopPanicAlarmLoop } from '@shared/lib/alarm';
import { fetchActivePanicLogs, needsAcknowledgement } from './api';

/**
 * Drives the NOC alarm from the layout, not from a screen — a guard switching
 * to History must not silence a live panic, and a panic raised while they are
 * on History must still sound. Shares the `['panic','active']` query with the
 * dashboard, so this adds no extra network traffic.
 */
export function usePanicAlarm(): void {
  const { data } = useQuery({
    queryKey: ['panic', 'active'],
    queryFn: fetchActivePanicLogs,
    refetchInterval: env.panicPollIntervalMs,
  });

  const hasUnacked = (data ?? []).some(needsAcknowledgement);

  useEffect(() => {
    if (hasUnacked) startPanicAlarmLoop();
    else stopPanicAlarmLoop();
    return () => stopPanicAlarmLoop();
  }, [hasUnacked]);
}
